import {useEffect} from 'react';

// Toggles a body class to disable selection globally while enabled
export default function useGlobalSelectionLock(enabled) {
    useEffect(() => {
        const body = typeof document !== 'undefined' ? document.body : null;
        if (!body) return;
        if (enabled) {
            body.classList.add('evidence-modal-open');
        } else {
            body.classList.remove('evidence-modal-open');
        }
        return () => body.classList.remove('evidence-modal-open');
    }, [enabled]);
}

